import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import Pagination from '@/components/ui/pagination/Pagination'

import { usePatientConsultations } from '../model/usePatientConsultations'
import { PatientConsultation } from './PatientConsultation'

export type SimplePagination = {
  pageIndex: number
  pageSize: number
  totalItems: number
}

export type PatientConsultationsProps = {
  itemsPerPageOptions?: number[]
  patientId: string
}

export function PatientConsultations({ itemsPerPageOptions = [5, 10, 25], patientId }: PatientConsultationsProps) {
  const { t } = useTranslation()

  const { patientHistoricalConsultations, paginationState, setPaginationState, totalConsultations } = usePatientConsultations(patientId, itemsPerPageOptions)

  const handlePageChange = (page: number, itemsPerPage: number) => {
    setPaginationState({ pageIndex: page - 1, pageSize: itemsPerPage })
  }

  const handleItemsPerPageChange = (newItemsPerPage: number) => {
    setPaginationState({ pageIndex: 0, pageSize: newItemsPerPage })
  }

  return (
    <Stack direction="column" spacing="10px" position="relative">
      <Typography mb="20px" fontWeight="800" fontSize="20px">
        {t('page.liveConsultation.consultationsHistorical.title')}
      </Typography>
      {patientHistoricalConsultations.map((consultation) => {
        return <PatientConsultation key={consultation.id} consultation={consultation} />
      })}

      {patientHistoricalConsultations.length > 0 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Pagination
            page={paginationState.pageIndex + 1}
            totalItems={totalConsultations}
            onPageChange={handlePageChange}
            onItemsPerPageChange={handleItemsPerPageChange}
            defaultItemsPerPage={paginationState.pageSize}
            itemsPerPageOptions={itemsPerPageOptions}
          />
        </Box>
      )}
    </Stack>
  )
}

export default PatientConsultations
